// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.marqueeContainer {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  background-color: transparent;
  backdrop-filter: blur(0);
  -webkit-backdrop-filter: blur(0);
  transition: background-color 0.25s linear, backdrop-filter 0.25s linear, -webkit-backdrop-filter 0.25s linear;
  overflow: hidden;
  padding: 1rem;
  box-sizing: border-box;
}

.marqueeContainer .marqueeItem,
.marqueeContainer .marqueeItem p {
  font-family: var(--font-heading);
  font-weight: 600;
  font-size: 3.4rem;
  line-height: 1.15;
}

.marqueeContainer.active {
  background-color: rgba(14, 36, 99, 0.55);
  backdrop-filter: blur(6px);
  -webkit-backdrop-filter: blur(6px);
}

/* Standings beat: keep team score panels readable under/around the card. */
.marqueeContainer.active.clearBackdrop {
  background-color: transparent;
  backdrop-filter: blur(0);
  -webkit-backdrop-filter: blur(0);
}

/* White card with a pink accent bar down the left edge. */
.marqueeContainer .marqueeItem {
  box-sizing: border-box;
  position: relative;
  border-radius: 16px;
  padding: 1.25rem 2.75rem 1.25rem 3rem;
  background-color: var(--white);
  color: var(--ink);
  transform: translateY(16px) scale(0.97);
  transition: transform 0.18s ease-in, box-shadow 0.18s ease;
  text-align: center;
  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.35);
  max-width: calc(100vw - 2rem);
  overflow: hidden;
}

.marqueeContainer .marqueeItem::before {
  content: "";
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 10px;
  background: var(--pink);
}

.marqueeContainer .marqueeItem.team1::before {
  background: var(--blue);
}

.marqueeContainer .marqueeItem.team2::before {
  background: var(--pink);
}

.marqueeContainer .marqueeItem.tie::before {
  background: linear-gradient(to bottom, var(--blue) 50%, var(--pink) 50%);
}

/* Full-bleed items (team picking) don't need the accent bar. */
.marqueeContainer .marqueeItem:has(.teamPicker) {
  padding: 0;
}

.marqueeContainer .marqueeItem:has(.teamPicker)::before {
  display: none;
}

.marqueeItem.active {
  transform: translateY(0) scale(1);
  transition-duration: 0.36s;
  transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
}

.marqueeItem.team1.active {
  box-shadow:
    0 16px 50px rgba(0, 0, 0, 0.3),
    0 0 0 2px rgba(56, 182, 245, 0.28),
    0 10px 28px rgba(56, 182, 245, 0.22);
}

.marqueeItem.team2.active {
  box-shadow:
    0 16px 50px rgba(0, 0, 0, 0.3),
    0 0 0 2px rgba(240, 110, 163, 0.28),
    0 10px 28px rgba(240, 110, 163, 0.22);
}

.marqueeItem.tie.active {
  box-shadow:
    0 16px 50px rgba(0, 0, 0, 0.3),
    0 0 0 2px rgba(56, 182, 245, 0.2),
    0 10px 24px rgba(240, 110, 163, 0.22);
}

.marqueeContainer.clearBackdrop .marqueeItem {
  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.9);
}

.marqueeContainer.clearBackdrop .marqueeItem.active {
  box-shadow:
    0 18px 56px rgba(0, 0, 0, 0.5),
    0 0 0 1px rgba(255, 255, 255, 0.7);
}

.marqueeInner {
  opacity: 0;
  transform: translateY(10px);
}

.marqueeItem.active .marqueeInner {
  animation: marqueeCopyIn 0.48s 0.08s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.marqueeItem.active .marqueeInner:has(.marqueeReveal),
.marqueeItem:has(.teamPicker) .marqueeInner {
  opacity: 1;
  transform: none;
  animation: none;
}

.marqueeItem:has(.teamPicker) .marqueeInner {
  width: 100%;
}

.marqueeItem > * {
  margin: 0;
  padding: 0;
}

.marqueeItem b {
  font-weight: 600;
}

.marqueeReveal {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.marqueeFlourish {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.75rem;
  margin-bottom: 0.55rem;
  opacity: 0;
  transform: translateY(8px);
}

.marqueeItem.active .marqueeFlourish {
  animation: marqueeCopyIn 0.45s 0.06s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.marqueeTrophy {
  width: 2.75rem;
  height: 2.75rem;
}

.marqueeItem.team1 .marqueeTrophy {
  color: var(--team1-text);
}

.marqueeItem.team2 .marqueeTrophy {
  color: var(--team2-text);
}

.marqueeTieDots {
  display: flex;
  align-items: center;
}

.marqueeTieDot {
  width: 1.4rem;
  height: 1.4rem;
  border-radius: 50%;
  box-shadow: 0 2px 6px rgba(14, 36, 99, 0.18);
}

.marqueeTieDot.blue {
  background: var(--blue);
}

.marqueeTieDot.pink {
  background: var(--pink);
  margin-left: -0.5rem;
}

.marqueeContainer .marqueeItem p.marqueeHeadline,
.marqueeHeadline {
  font-size: 4.2rem;
  line-height: 1.05;
  transform: translateY(12px);
  opacity: 0;
}

.marqueeItem.team1 .marqueeHeadline {
  color: var(--team1-text);
}

.marqueeItem.team2 .marqueeHeadline {
  color: var(--team2-text);
}

.marqueeItem.active .marqueeHeadline {
  animation: marqueeCopyIn 0.5s 0.1s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.marqueeContainer .marqueeItem p.marqueeSubhead,
.marqueeSubhead {
  font-size: 1.8rem;
  font-weight: 500;
  color: var(--ink-soft);
  margin-top: 0.35rem;
  opacity: 0;
  transform: translateY(8px);
}

.marqueeItem.active .marqueeSubhead {
  animation: marqueeCopyIn 0.48s 0.2s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.marqueeContainer .marqueeItem p.marqueeReason,
.marqueeReason {
  font-size: 1.45rem;
  font-weight: 500;
  line-height: 1.25;
  text-align: center;
  color: var(--ink-soft);
  margin-top: 0.55rem;
  max-width: 38rem;
  opacity: 0;
  transform: translateY(8px);
}

.marqueeItem.active .marqueeReason {
  animation: marqueeCopyIn 0.48s 0.28s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

/* Player names in marquee copy — bigger, glowing, readable from the back of the room. */
.marqueePlayer {
  display: inline-block;
  font-family: var(--font-heading);
  font-weight: 700;
  font-size: 1.28em;
  line-height: 1.05;
  letter-spacing: 0.01em;
  white-space: nowrap;
  vertical-align: baseline;
  color: var(--navy);
  text-shadow:
    0 0 0.04em var(--white),
    0 0 0.16em rgba(255, 255, 255, 0.95),
    0 0 0.4em rgba(56, 182, 245, 0.55),
    0 0 0.85em rgba(240, 110, 163, 0.4);
  animation: marqueePlayerBob 1.7s ease-in-out infinite;
}

.marqueePlayer.team1 {
  color: var(--team1-text);
  text-shadow:
    0 0 0.04em var(--white),
    0 0 0.14em rgba(255, 255, 255, 0.95),
    0 0 0.4em rgba(56, 182, 245, 0.8),
    0 0 0.85em rgba(56, 182, 245, 0.45);
}

.marqueePlayer.team2 {
  color: var(--team2-text);
  text-shadow:
    0 0 0.04em var(--white),
    0 0 0.14em rgba(255, 255, 255, 0.95),
    0 0 0.4em rgba(240, 110, 163, 0.8),
    0 0 0.85em rgba(240, 110, 163, 0.45);
}

.marqueeHeadline .marqueePlayer {
  font-size: 1em;
}

/* Compact lists: keep glow/color, skip the size bump so rows don't clip. */
.summaryRow .marqueePlayer {
  font-size: inherit;
  animation: none;
}

@keyframes marqueePlayerBob {
  0%,
  100% {
    transform: translateY(0);
    filter: brightness(1);
  }

  50% {
    transform: translateY(-0.07em);
    filter: brightness(1.12);
  }
}

@media (prefers-reduced-motion: reduce) {
  .marqueePlayer {
    animation: none;
  }
}

@keyframes marqueeCopyIn {
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.marqueeDots span {
  opacity: 0.2;
  animation: marqueeDotPulse 1.2s infinite;
}

.marqueeDots span:nth-child(2) {
  animation-delay: 0.2s;
}

.marqueeDots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes marqueeDotPulse {
  0%,
  100% {
    opacity: 0.2;
  }

  40% {
    opacity: 1;
  }
}

@media (max-width: 600px) {
  .marqueeContainer .marqueeItem,
  .marqueeContainer .marqueeItem p {
    font-size: 2.2rem;
  }

  .marqueeContainer .marqueeItem p.marqueeHeadline,
  .marqueeHeadline {
    font-size: 2.8rem;
  }

  .marqueeContainer .marqueeItem p.marqueeSubhead,
  .marqueeSubhead {
    font-size: 1.3rem;
  }

  .marqueeContainer .marqueeItem p.marqueeReason,
  .marqueeReason {
    font-size: 1.05rem;
    max-width: 22rem;
  }

  .marqueeContainer .marqueeItem {
    padding: 1rem 1.5rem 1rem 1.75rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/browser/webapp/components/room/shared/marquee.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,wBAAwB;EACxB,gCAAgC;EAChC,6GAA6G;EAC7G,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,wCAAwC;EACxC,0BAA0B;EAC1B,kCAAkC;AACpC;;AAEA,2EAA2E;AAC3E;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,gCAAgC;AAClC;;AAEA,0DAA0D;AAC1D;EACE,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,8BAA8B;EAC9B,iBAAiB;EACjB,uCAAuC;EACvC,0DAA0D;EAC1D,kBAAkB;EAClB,2CAA2C;EAC3C,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS;EACT,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wEAAwE;AAC1E;;AAEA,+DAA+D;AAC/D;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iCAAiC;EACjC,0BAA0B;EAC1B,0DAA0D;AAC5D;;AAEA;EACE;;;wCAGsC;AACxC;;AAEA;EACE;;;yCAGuC;AACzC;;AAEA;EACE;;;yCAGuC;AACzC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;;sCAEoC;AACtC;;AAEA;EACE,UAAU;EACV,2BAA2B;AAC7B;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;;EAEE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,sBAAsB;EACtB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;;EAEE,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0EAA0E;AAC5E;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,2EAA2E;AAC7E;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,gBAAgB;EAChB,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,4EAA4E;AAC9E;;AAEA,wFAAwF;AACxF;EACE,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB;;;;uCAIqC;EACrC,qDAAqD;AACvD;;AAEA;EACE,wBAAwB;EACxB;;;;uCAIqC;AACvC;;AAEA;EACE,wBAAwB;EACxB;;;;wCAIsC;AACxC;;AAEA;EACE,cAAc;AAChB;;AAEA,2EAA2E;AAC3E;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE;;IAEE,wBAAwB;IACxB,qBAAqB;EACvB;;EAEA;IACE,8BAA8B;IAC9B,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA;EACE,YAAY;EACZ,wCAAwC;AAC1C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE;;IAEE,YAAY;EACd;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,iCAAiC;EACnC;AACF","sourcesContent":[".marqueeContainer {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  margin: 0 auto;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10;\n  background-color: transparent;\n  backdrop-filter: blur(0);\n  -webkit-backdrop-filter: blur(0);\n  transition: background-color 0.25s linear, backdrop-filter 0.25s linear, -webkit-backdrop-filter 0.25s linear;\n  overflow: hidden;\n  padding: 1rem;\n  box-sizing: border-box;\n}\n\n.marqueeContainer .marqueeItem,\n.marqueeContainer .marqueeItem p {\n  font-family: var(--font-heading);\n  font-weight: 600;\n  font-size: 3.4rem;\n  line-height: 1.15;\n}\n\n.marqueeContainer.active {\n  background-color: rgba(14, 36, 99, 0.55);\n  backdrop-filter: blur(6px);\n  -webkit-backdrop-filter: blur(6px);\n}\n\n/* Standings beat: keep team score panels readable under/around the card. */\n.marqueeContainer.active.clearBackdrop {\n  background-color: transparent;\n  backdrop-filter: blur(0);\n  -webkit-backdrop-filter: blur(0);\n}\n\n/* White card with a pink accent bar down the left edge. */\n.marqueeContainer .marqueeItem {\n  box-sizing: border-box;\n  position: relative;\n  border-radius: 16px;\n  padding: 1.25rem 2.75rem 1.25rem 3rem;\n  background-color: var(--white);\n  color: var(--ink);\n  transform: translateY(16px) scale(0.97);\n  transition: transform 0.18s ease-in, box-shadow 0.18s ease;\n  text-align: center;\n  box-shadow: 0 16px 50px rgba(0, 0, 0, 0.35);\n  max-width: calc(100vw - 2rem);\n  overflow: hidden;\n}\n\n.marqueeContainer .marqueeItem::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  width: 10px;\n  background: var(--pink);\n}\n\n.marqueeContainer .marqueeItem.team1::before {\n  background: var(--blue);\n}\n\n.marqueeContainer .marqueeItem.team2::before {\n  background: var(--pink);\n}\n\n.marqueeContainer .marqueeItem.tie::before {\n  background: linear-gradient(to bottom, var(--blue) 50%, var(--pink) 50%);\n}\n\n/* Full-bleed items (team picking) don't need the accent bar. */\n.marqueeContainer .marqueeItem:has(.teamPicker) {\n  padding: 0;\n}\n\n.marqueeContainer .marqueeItem:has(.teamPicker)::before {\n  display: none;\n}\n\n.marqueeItem.active {\n  transform: translateY(0) scale(1);\n  transition-duration: 0.36s;\n  transition-timing-function: cubic-bezier(0.22, 1, 0.36, 1);\n}\n\n.marqueeItem.team1.active {\n  box-shadow:\n    0 16px 50px rgba(0, 0, 0, 0.3),\n    0 0 0 2px rgba(56, 182, 245, 0.28),\n    0 10px 28px rgba(56, 182, 245, 0.22);\n}\n\n.marqueeItem.team2.active {\n  box-shadow:\n    0 16px 50px rgba(0, 0, 0, 0.3),\n    0 0 0 2px rgba(240, 110, 163, 0.28),\n    0 10px 28px rgba(240, 110, 163, 0.22);\n}\n\n.marqueeItem.tie.active {\n  box-shadow:\n    0 16px 50px rgba(0, 0, 0, 0.3),\n    0 0 0 2px rgba(56, 182, 245, 0.2),\n    0 10px 24px rgba(240, 110, 163, 0.22);\n}\n\n.marqueeContainer.clearBackdrop .marqueeItem {\n  text-shadow: 0 1px 0 rgba(255, 255, 255, 0.9);\n}\n\n.marqueeContainer.clearBackdrop .marqueeItem.active {\n  box-shadow:\n    0 18px 56px rgba(0, 0, 0, 0.5),\n    0 0 0 1px rgba(255, 255, 255, 0.7);\n}\n\n.marqueeInner {\n  opacity: 0;\n  transform: translateY(10px);\n}\n\n.marqueeItem.active .marqueeInner {\n  animation: marqueeCopyIn 0.48s 0.08s cubic-bezier(0.22, 1, 0.36, 1) forwards;\n}\n\n.marqueeItem.active .marqueeInner:has(.marqueeReveal),\n.marqueeItem:has(.teamPicker) .marqueeInner {\n  opacity: 1;\n  transform: none;\n  animation: none;\n}\n\n.marqueeItem:has(.teamPicker) .marqueeInner {\n  width: 100%;\n}\n\n.marqueeItem > * {\n  margin: 0;\n  padding: 0;\n}\n\n.marqueeItem b {\n  font-weight: 600;\n}\n\n.marqueeReveal {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n.marqueeFlourish {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 2.75rem;\n  margin-bottom: 0.55rem;\n  opacity: 0;\n  transform: translateY(8px);\n}\n\n.marqueeItem.active .marqueeFlourish {\n  animation: marqueeCopyIn 0.45s 0.06s cubic-bezier(0.22, 1, 0.36, 1) forwards;\n}\n\n.marqueeTrophy {\n  width: 2.75rem;\n  height: 2.75rem;\n}\n\n.marqueeItem.team1 .marqueeTrophy {\n  color: var(--team1-text);\n}\n\n.marqueeItem.team2 .marqueeTrophy {\n  color: var(--team2-text);\n}\n\n.marqueeTieDots {\n  display: flex;\n  align-items: center;\n}\n\n.marqueeTieDot {\n  width: 1.4rem;\n  height: 1.4rem;\n  border-radius: 50%;\n  box-shadow: 0 2px 6px rgba(14, 36, 99, 0.18);\n}\n\n.marqueeTieDot.blue {\n  background: var(--blue);\n}\n\n.marqueeTieDot.pink {\n  background: var(--pink);\n  margin-left: -0.5rem;\n}\n\n.marqueeContainer .marqueeItem p.marqueeHeadline,\n.marqueeHeadline {\n  font-size: 4.2rem;\n  line-height: 1.05;\n  transform: translateY(12px);\n  opacity: 0;\n}\n\n.marqueeItem.team1 .marqueeHeadline {\n  color: var(--team1-text);\n}\n\n.marqueeItem.team2 .marqueeHeadline {\n  color: var(--team2-text);\n}\n\n.marqueeItem.active .marqueeHeadline {\n  animation: marqueeCopyIn 0.5s 0.1s cubic-bezier(0.22, 1, 0.36, 1) forwards;\n}\n\n.marqueeContainer .marqueeItem p.marqueeSubhead,\n.marqueeSubhead {\n  font-size: 1.8rem;\n  font-weight: 500;\n  color: var(--ink-soft);\n  margin-top: 0.35rem;\n  opacity: 0;\n  transform: translateY(8px);\n}\n\n.marqueeItem.active .marqueeSubhead {\n  animation: marqueeCopyIn 0.48s 0.2s cubic-bezier(0.22, 1, 0.36, 1) forwards;\n}\n\n.marqueeContainer .marqueeItem p.marqueeReason,\n.marqueeReason {\n  font-size: 1.45rem;\n  font-weight: 500;\n  line-height: 1.25;\n  text-align: center;\n  color: var(--ink-soft);\n  margin-top: 0.55rem;\n  max-width: 38rem;\n  opacity: 0;\n  transform: translateY(8px);\n}\n\n.marqueeItem.active .marqueeReason {\n  animation: marqueeCopyIn 0.48s 0.28s cubic-bezier(0.22, 1, 0.36, 1) forwards;\n}\n\n/* Player names in marquee copy — bigger, glowing, readable from the back of the room. */\n.marqueePlayer {\n  display: inline-block;\n  font-family: var(--font-heading);\n  font-weight: 700;\n  font-size: 1.28em;\n  line-height: 1.05;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n  vertical-align: baseline;\n  color: var(--navy);\n  text-shadow:\n    0 0 0.04em var(--white),\n    0 0 0.16em rgba(255, 255, 255, 0.95),\n    0 0 0.4em rgba(56, 182, 245, 0.55),\n    0 0 0.85em rgba(240, 110, 163, 0.4);\n  animation: marqueePlayerBob 1.7s ease-in-out infinite;\n}\n\n.marqueePlayer.team1 {\n  color: var(--team1-text);\n  text-shadow:\n    0 0 0.04em var(--white),\n    0 0 0.14em rgba(255, 255, 255, 0.95),\n    0 0 0.4em rgba(56, 182, 245, 0.8),\n    0 0 0.85em rgba(56, 182, 245, 0.45);\n}\n\n.marqueePlayer.team2 {\n  color: var(--team2-text);\n  text-shadow:\n    0 0 0.04em var(--white),\n    0 0 0.14em rgba(255, 255, 255, 0.95),\n    0 0 0.4em rgba(240, 110, 163, 0.8),\n    0 0 0.85em rgba(240, 110, 163, 0.45);\n}\n\n.marqueeHeadline .marqueePlayer {\n  font-size: 1em;\n}\n\n/* Compact lists: keep glow/color, skip the size bump so rows don't clip. */\n.summaryRow .marqueePlayer {\n  font-size: inherit;\n  animation: none;\n}\n\n@keyframes marqueePlayerBob {\n  0%,\n  100% {\n    transform: translateY(0);\n    filter: brightness(1);\n  }\n\n  50% {\n    transform: translateY(-0.07em);\n    filter: brightness(1.12);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .marqueePlayer {\n    animation: none;\n  }\n}\n\n@keyframes marqueeCopyIn {\n  to {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}\n\n.marqueeDots span {\n  opacity: 0.2;\n  animation: marqueeDotPulse 1.2s infinite;\n}\n\n.marqueeDots span:nth-child(2) {\n  animation-delay: 0.2s;\n}\n\n.marqueeDots span:nth-child(3) {\n  animation-delay: 0.4s;\n}\n\n@keyframes marqueeDotPulse {\n  0%,\n  100% {\n    opacity: 0.2;\n  }\n\n  40% {\n    opacity: 1;\n  }\n}\n\n@media (max-width: 600px) {\n  .marqueeContainer .marqueeItem,\n  .marqueeContainer .marqueeItem p {\n    font-size: 2.2rem;\n  }\n\n  .marqueeContainer .marqueeItem p.marqueeHeadline,\n  .marqueeHeadline {\n    font-size: 2.8rem;\n  }\n\n  .marqueeContainer .marqueeItem p.marqueeSubhead,\n  .marqueeSubhead {\n    font-size: 1.3rem;\n  }\n\n  .marqueeContainer .marqueeItem p.marqueeReason,\n  .marqueeReason {\n    font-size: 1.05rem;\n    max-width: 22rem;\n  }\n\n  .marqueeContainer .marqueeItem {\n    padding: 1rem 1.5rem 1rem 1.75rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
